import { API_CONFIG } from '../../../config/api';
import { apiClient } from '../../../utils/apiClient';
import { tokenManager } from '../../../utils/tokenManager';
import type { FilterOption, KioskReportBodies, KioskReportFilterValues, KioskReportTab } from './types';

export function kioskReportQuery(filters: KioskReportFilterValues): string {
  const params = new URLSearchParams({ start_date: filters.startDate, end_date: filters.endDate });
  if (filters.siteId !== '') params.set('site_id', filters.siteId);
  if (filters.kioskId !== '') params.set('kiosk_id', filters.kioskId);
  if (filters.method !== '') params.set('method', filters.method);
  return `?${params.toString()}`;
}

export function loadKioskReport<T extends KioskReportTab>(tab: T, filters: KioskReportFilterValues): Promise<KioskReportBodies[T]> {
  return apiClient.get<KioskReportBodies[T]>(`/api/backend/reports/kiosk/${tab}${kioskReportQuery(filters)}`);
}

export async function downloadKioskReportCsv(tab: KioskReportTab, filters: KioskReportFilterValues): Promise<void> {
  const token = await tokenManager.getAccessToken();
  if (token === null) throw new Error('Not signed in');
  const response = await fetch(`${API_CONFIG.baseURL}/api/backend/reports/kiosk/${tab}/export${kioskReportQuery(filters)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`Export failed with ${response.status}`);
  const url = window.URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = url;
  link.download = `kiosk-report-${tab}-${filters.startDate}-to-${filters.endDate}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
}

export async function loadReportSites(): Promise<FilterOption[]> {
  const body = await apiClient.get<{ data: FilterOption[] }>('/api/backend/reports/filters/sites');
  return body.data.map((site) => ({ id: site.id, name: site.name }));
}

export async function loadReportKiosks(siteId: string): Promise<FilterOption[]> {
  const query = siteId === '' ? '' : `?site_id=${encodeURIComponent(siteId)}`;
  const body = await apiClient.get<{ data: Array<FilterOption & { site_id: string }> }>(`/api/backend/reports/filters/kiosks${query}`);
  return body.data.map((kiosk) => ({ id: kiosk.id, name: kiosk.name }));
}
